webpackJsonp([35783957827783],{

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	    return _react2.default.createElement(
	        'footer',
	        { id: 'footer', style: props.timeout ? { display: 'none' } : {} },
	        _react2.default.createElement(
	            'p',
	            { className: 'copyright' },
	            '\xA9 David Wu. All rights reserved.'
	        )
	    );
	};
	
	Footer.propTypes = {
	    timeout: _propTypes2.default.bool
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	    _inherits(Header, _Component);
	
	    function Header() {
	        _classCallCheck(this, Header);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Header.prototype.componentDidMount = function componentDidMount() {
	        this.props.onMenuIn();
	    };
	
	    Header.prototype.render = function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	            'header',
	            { id: 'header', style: this.props.timeout ? { display: 'none' } : {} },
	            _react2.default.createElement(
	                'div',
	                { className: 'logo' },
	                _react2.default.createElement('span', { className: 'icon fa-terminal' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'David\'s'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Hi there, welcome to my site. I hope you find it interesting.',
	                        _react2.default.createElement('br', null),
	                        ' Feel free to contact me if you want to know more about me or just want a chat!'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'nav',
	                null,
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/intro', onClick: function onClick(event) {
	                                    return _this2.props.navigateWithTimeout("menu", "/intro", event);
	                                } },
	                            'Intro'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/work', onClick: function onClick(event) {
	                                    return _this2.props.navigateWithTimeout("menu", "/work", event);
	                                } },
	                            'Work'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/blog', onClick: function onClick(event) {
	                                    return _this2.props.navigateWithTimeout("menu", "/blog", event);
	                                } },
	                            'Blog'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/contact', onClick: function onClick(event) {
	                                    return _this2.props.navigateWithTimeout("menu", "/contact", event);
	                                } },
	                            'Contact'
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return Header;
	}(_react.Component);
	
	Header.propTypes = {
	    onOpenArticle: _propTypes2.default.func,
	    timeout: _propTypes2.default.bool
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(135);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(134);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(props) {
	  return _react2.default.createElement(
	    'div',
	    { id: 'wrapper' },
	    _react2.default.createElement(_Header2.default, {
	      onMenuIn: props.onMenuIn,
	      onMenuOut: props.onMenuOut,
	      timeout: props.timeout,
	      navigateWithTimeout: props.navigateWithTimeout
	    }),
	    _react2.default.createElement(_Footer2.default, { timeout: props.timeout })
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-2c1cf5c4bbaec7502fe1.js